import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom'; //https://stackoverflow.com/questions/42173786/react-router-pass-data-when-navigating-programmatically
import Nav from '../../components/Nav/Nav'
import './SearchScreen.css';
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../../features/currentUser'
import { Oval, MagnifyingGlass } from 'react-loader-spinner'
import { searchGroupsAlgolia, searchMoreUsersFir, searchPremiumMessagesAlgolia, searchUsers } from '../../services/f';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry" //https://youtu.be/RDxnu8Xt5Rk + https://cedricdelpoux.github.io/react-responsive-masonry/
import { BsBrowserSafari, BsPlusCircle } from 'react-icons/bs'  //https://react-icons.github.io/react-icons
import UserRows, { AlgoliaGroupRows, AlgoliaPMRows, AlgoliaResultsRows } from '../../components/UserRows/UserRows';
import { FiSearch } from 'react-icons/fi'
import Footer from '../../components/Footer'
import { auth } from '../../firebase';
import VerifyEmailComponent from '../../components/rememberverifyemail';
import { Helmet } from 'react-helmet';

function SearchScreen() {
    // http://localhost:3000/search?q=sdffsdf
    // http://localhost:3000/search?q=MFbwMsG0SkVnOYTUMZRKeshqBmA2
    const [searchParams, setSearchParams] = useSearchParams();
    let currentUser = useSelector(getCurrentUser).currentUser?.currentUser// ALSO WENNS n user gibt dann wird anderes screen angezeigt
    const navigate = useNavigate()

    const [searchResults, setsearchResults] = useState([]);
    const [newsearchedUsers, setnewsearchedUsers] = useState([]);
    const [lastVisiblesearchuser, setlastVisiblesearchuser] = useState();
    const [lastsearchUser, setlastsearchUser] = useState(false);

    const [searchtext, setsearchtext] = useState("");
    const [notxt, setnotxt] = useState(false);

    const [showMorebtn, setshowMorebtn] = useState(true);

    // for groups and premiummessages algolia search
    const [searchedalgolia, setsearchedalgolia] = useState([]);
    const [extrasearch, setextrasearch] = useState(0);
    const [algoliapage, setalgoliapage] = useState(0);
    const [lastalgoliapage, setlastalgoliapage] = useState(false);


    useEffect(() => {
        // check if user or psot available then query for them and show them
        // get specific   searchParams.get("code")

        let searchtext = searchParams.get("q")
        //console.log(searchtext)
        setlastsearchUser(false)
        setsearchResults([])
        setlastVisiblesearchuser()
        setnewsearchedUsers([])
        setshowMorebtn(true)
        setnotxt(false)

        if (searchtext === null || searchtext === undefined || searchtext === "") {
            //console.log("no search")
            setnotxt(true)
        } else {
            searchUsers(searchtext.toLowerCase()).then((res) => {
                //console.log("searchUsers result", res)
                setsearchResults(res)
            })
        }
    }, [searchParams.get("q")]);

    useEffect(() => {
       //console.log("these r length of searchedposts", searchResults)
        // searchResults.length === 1 ? setlastsearchUser(true) : null
        if (searchResults.length === 1) {
            setlastsearchUser(true)
        }
        const lastitem = searchResults.slice(-1)
        setlastVisiblesearchuser(lastitem[0])
    }, [searchResults]);

    useEffect(() => {
        //console.log("newsearchedposts.length", newsearchedUsers.length)
        newsearchedUsers.length === 1 ? setlastsearchUser(true) : setlastsearchUser(false)
        //searchResults.length > 40 ? setlastsearchUser(true) : null
        if (searchResults.length > 40) {
            setlastsearchUser(true)
        }
        setsearchResults([...searchResults.slice(0, -1), ...newsearchedUsers])
    }, [newsearchedUsers]);

    const searchExtraFunction = (option) => {
        let searchtext = searchParams.get("q")
        setsearchedalgolia([])
        setextrasearch(option)
        setalgoliapage(0)
        setlastalgoliapage(false)

        if (option === 1) {
            searchPremiumMessagesAlgolia(searchtext.toLowerCase(), currentUser, 0).then((pms) => {
                //console.log("searchPremiumMessagesAlgolia", pms)
                if (pms.length === 0) {
                    setsearchedalgolia(["nothing"])
                    setlastalgoliapage(true)
                    return
                } else {
                    setsearchedalgolia(pms)
                }
            })

        } else if (option === 2) {
            searchGroupsAlgolia(searchtext.toLowerCase(), currentUser, 0).then((groups) => {
                //console.log("found groups", groups)
                if (groups.length === 0) {
                    setsearchedalgolia(["nothing"])
                    setlastalgoliapage(true)
                    return
                } else {
                    setsearchedalgolia(groups)
                }
            })
        }
    }

    const searchMoreAlgolia = () => {
        let searchtext = searchParams.get("q")
       // console.log("search searchMoreAlgolia", extrasearch, searchtext)
        if (extrasearch === 1) {
            searchPremiumMessagesAlgolia(searchtext.toLowerCase(), currentUser, algoliapage + 1).then((pms) => {
                //console.log("searchPremiumMessagesAlgolia", pms.length)
                if (pms.length === 0) {
                    setlastalgoliapage(true)
                    return
                } else {
                    setsearchedalgolia([...searchedalgolia, pms])
                }
            })

        } else if (extrasearch === 2) {
            searchGroupsAlgolia(searchtext.toLowerCase(), currentUser, algoliapage + 1).then((groups) => {
                //console.log("found more groups", groups.length)
                setalgoliapage(algoliapage + 1)
                if (groups.length === 0) {
                    setlastalgoliapage(true)
                    return
                } else {
                    setsearchedalgolia([...searchedalgolia, groups])
                }
            })
        }
    }

    const searchMoreUsers = () => {
        if (lastVisiblesearchuser === undefined) {
            return
        }
        if (!lastsearchUser) {
            searchMoreUsersFir(searchParams.get("q").toLowerCase(), lastVisiblesearchuser).then(setnewsearchedUsers)
        }
    }

    const handleSearchSubmit = (e) => {
        e.preventDefault()
        setextrasearch(0)
        navigate("/search?q=" + searchtext)
    }

    const searchForm = (
        <form onSubmit={handleSearchSubmit} className="search-page__form">
            <input onChange={(e) => setsearchtext(e.target.value)} value={searchtext} className="search-page__input" type="search" placeholder="Search users, groups & messages" aria-label="Search users, groups and messages" />
            <button type="submit" className="search-page__form-icon" aria-label="Search"><FiSearch size={26} color="#009ffd" /></button>
        </form>
    )

    return (
        <div className="searchscreen">
            <Helmet>
                <meta property="og:title" content="Premsi - Search Users/Groups/Premium Messages" />
                <meta property="og:description" content="Premsi | Sell and market digital content in seconds . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <meta property="og:url" content="https://premsi.com/search" />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
                <meta property="og:site_name" content="Premsi - sell digital content" />
                <link rel="canonical" href="https://premsi.com/search" />
                <meta name="description" content="Premsi | Search other Premsi Users/Groups/Premium Messages here . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <title>Premsi - Search Users/Groups/Premium Messages</title>
            </Helmet>
            <Nav />
            {auth.currentUser === null || auth.currentUser === undefined || auth.currentUser.emailVerified === true ? null : <VerifyEmailComponent />}

            <div className="search-page">
                <div className="search-page__bar">
                    <p className="search-page__bar-label">Or Search for</p>
                    {searchForm}
                    <div className="search-page__filters">
                        <button type="button" className={`search-page__filter ${extrasearch === 1 ? 'search-page__filter--active' : ''}`} onClick={() => searchExtraFunction(1)} aria-pressed={extrasearch === 1}>Premium Messages</button>
                        <button type="button" className={`search-page__filter ${extrasearch === 2 ? 'search-page__filter--active' : ''}`} onClick={() => searchExtraFunction(2)} aria-pressed={extrasearch === 2}>Groups</button>
                    </div>
                </div>

                {extrasearch === 0 ? (
                    <div className="search-page__results">
                        {searchResults.length === 0 && notxt === false ? (
                            <div className="search-page__state search-page__state--loading">
                                <Oval height={40} width={40} color="#009FFD" wrapperStyle={{}} wrapperClass="" visible={true} ariaLabel="oval-loading" secondaryColor="white" strokeWidth={5} strokeWidthSecondary={5} />
                                <h2 className="search-page__state-title">Loading search results...</h2>
                                <p className="search-page__state-text">If this takes too long please refresh this window.</p>
                            </div>
                        ) : notxt ? (
                            <div className="search-page__state">
                                <h2 className="search-page__state-title">Search through Premsi.com <span className="font-body-inline">-</span> The easiest way to sell digital content</h2>
                                {searchForm}
                            </div>
                        ) : searchResults.length === 1 && searchResults[0] === undefined ? (
                            <div className="search-page__state">
                                <h2 className="search-page__state-title">Oops! Seems like there are no users for your search...</h2>
                                {searchForm}
                            </div>
                        ) : (
                            <div className="search-page__list">
                                {searchResults.slice(0, -1).map((userdata) => (
                                    <UserRows key={userdata[0]} user={userdata} />
                                ))}
                                {!lastsearchUser ? (
                                    <button type="button" className="search-page__load-more" onClick={() => searchMoreUsers()} aria-label="Load more users">
                                        <BsPlusCircle size={28} color="#009FFD" />
                                    </button>
                                ) : (
                                    <p className="search-page__end-message">These are all users</p>
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="search-page__results">
                        {searchedalgolia.length === 0 && notxt === false ? (
                            <div className="search-page__state search-page__state--loading">
                                <Oval height={40} width={40} color="#009FFD" wrapperStyle={{}} wrapperClass="" visible={true} ariaLabel="oval-loading" secondaryColor="white" strokeWidth={5} strokeWidthSecondary={5} />
                                <h2 className="search-page__state-title">Loading search results...</h2>
                                <p className="search-page__state-text">If this takes too long please refresh this window.</p>
                            </div>
                        ) : notxt ? (
                            <div className="search-page__state">
                                <h2 className="search-page__state-title">Oops! Seems like you didn't search anything...</h2>
                                {searchForm}
                            </div>
                        ) : searchedalgolia.length === 1 && searchedalgolia[0] === "nothing" ? (
                            <div className="search-page__state">
                                <h2 className="search-page__state-title">Oops! Seems like there are no {extrasearch === 1 ? "Premium Messages" : "Groups"} for your search...</h2>
                                {searchForm}
                            </div>
                        ) : (
                            <div className="search-page__list">
                                <h2 className="search-page__list-title">These are your searched {extrasearch === 1 ? "Premium Messages" : "Groups"}</h2>
                                {searchedalgolia.map((results, index) => (
                                    extrasearch === 1 ? <AlgoliaPMRows key={results?.id ?? index} result={results} /> : <AlgoliaGroupRows key={results?.id ?? index} result={results} />
                                ))}
                                {!lastalgoliapage ? (
                                    <button type="button" className="search-page__load-more" onClick={() => searchMoreAlgolia()} aria-label="Load more">
                                        <BsPlusCircle size={28} color="#009FFD" />
                                    </button>
                                ) : (
                                    <p className="search-page__end-message">These are all results</p>
                                )}
                            </div>
                        )}
                        <p className="search-page__app-link">Download our <a href="/app">app</a> to purchase and view the premium messages and join the Groups</p>
                    </div>
                )}
            </div>

            <Footer />
        </div>
    )
}

export default SearchScreen
